// extracted by css-extract-rspack-plugin
export default {"container":"DroppableSlot_container__v3z2N","over":"DroppableSlot_over__tCo_o"};